"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMoney = void 0;
var Numeral = require("numeral");
exports.formatMoney = function (cents, format) {
    var regex = /\{\{\s*(\w+)\s*\}\}/;
    var stringFormat = format || "${{amount}}";
    var shopifyFormat = {
        amount: "0.00",
        amount_no_decimals: "0",
        amount_with_comma_separator: "0,0.00",
        amount_no_decimals_with_comma_separator: "0,0"
    };
    var replacement = Numeral(cents)
        .divide(100)
        .format(shopifyFormat[stringFormat.match(regex)[1]]);
    return stringFormat.replace(regex, replacement);
};
//# sourceMappingURL=format-money.js.map